import React, { PropsWithChildren } from 'react';
import { connect } from 'react-redux';
import { WebsiteState } from '@gift/website-state/store';
import { Prefab } from '@gift/basic-scene-core/Prefab';
import { selectPaintablesForPrefabPreview } from '../_redux-variants';
import { Paintable } from 'ff-canvas';
import { Preview2d } from '@gift/ui/components/preview/Preview2d';
import { Translate } from '@gift/types/generic/Translate';
import { TransformParameters } from '@gift/common/helpers/transformParameters';
import { selectTransformParametersForPreviewByPrefabId } from '@gift/basic-scene-website/_redux-prefabs';

const _FullPrefabPreview2d = ({ paintables, transformParameters }: Props) => (
    <Preview2d
        paintables={paintables}
        transformParameters={transformParameters}
    />
);

type Props = PropsWithChildren<{
    paintables: Paintable[],
    transformParameters: TransformParameters
}>;

const mapStateToProps = (
    state: WebsiteState,
    ownProps: { prefab: Prefab, t: Translate }
) => ({
    paintables: selectPaintablesForPrefabPreview(state, ownProps.prefab, ownProps.t),
    transformParameters: selectTransformParametersForPreviewByPrefabId(state, ownProps.prefab.id)
});

export const FullPrefabPreview2d = connect(
    mapStateToProps
)(_FullPrefabPreview2d);